import { CardBody, Form, FormGroup, Input, Label, TabContent, TabPane } from "reactstrap";
import { DalbultCaslin } from "../../../../Constant";
import { H6, Image, LI, P, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { TabContentProp } from "../../../../Type/UiKits";

export const BorderTabContent = ({basicTab}:TabContentProp) => {
  return (
    <TabContent activeTab={basicTab}>
      <TabPane tabId="1">
        <P className="pt-3">A navigation bar is a particularly important feature because it allows visitors to quickly and easily find <em className="txt-danger">important pages on your website,</em> like your blog, product pages, pricing, contact info, and documentation. This improves the chances of visitors browsing your site longer, which can boost your page views and reduce your bounce rate.Create product Builder tool is also pre-bundled in this template so that you can let the audience configure the product by themselves before placing the order.</P>
      </TabPane>
      <TabPane tabId="2">
        <CardBody className="pb-0">
          <div className="main-inbox">
            <div className="header-inbox">
              <div className="header-left-inbox">
                <div className="inbox-img">
                  <Image src={dynamicImage("ecommerce/06.jpg")} alt="profile" />
                </div>
                <div className="inbox-content">
                  <H6>{DalbultCaslin}</H6>
                  <P className="text-muted">stroman.rogers@gmail.com</P>
                </div>
              </div>
              <UL className="header-right-inbox d-flex flex-row simple-list">
                <LI><P>8 JAN 11:30PM</P></LI>
                <LI><i className="txt-danger icofont icofont-ui-delete"></i></LI>
                <LI><i className="icofont icofont-telegram"></i></LI>
              </UL>
            </div>
            <div className="body-inbox mt-2">
              <div className="body-h-wrapper"><i className="me-2 tab-space icofont icofont-star"></i><em>Compare Prices Find the Best Computer Assessors Fronted Issue.</em></div>
              <P className="pt-2">Site speed and design are two of the most important ranking factors Google takes into consideration, as they have the biggest effect of customer staying on site as the website respond faster.</P>
            </div>
          </div>
        </CardBody>
      </TabPane>
      <TabPane tabId="3">
        <CardBody className="px-0 pb-0">
          <Form>
            <FormGroup className="mb-3">
              <Label>Email address</Label>
              <Input type="email" placeholder="youremail@gmail.com" />
            </FormGroup>
            <FormGroup className="mb-0">
              <Label>Example textarea</Label>
              <Input type="textarea" className="form-control" id="exampleFormControlTextarea1" rows={3} />
            </FormGroup>
          </Form>
        </CardBody>
      </TabPane>
    </TabContent>
  );
};
